<template>
    <div class="checklist" v-if="artwork && order">
        <ul>
            <li v-for="(item, index) in comments">
                <span class="nmbr">{{item.version_number}}</span>
                <span class="txt" v-html="item.comment"></span>
                <a v-if="is_edit" href="javascript:void(0)" @click="deleteComment(index, item.id)" class="trashBtn"><i class="ri-delete-bin-6-line"></i></a>
            </li>
        </ul>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import { VueEditor } from "vue2-editor";

export default {
    name: "ArtworkComment",
    components: {
        VuePdfEmbed,
        VueEditor
    },
    props: ['order', 'artwork', 'is_edit', 'bus'],
    created() {

    },
    beforeMount() {

    },
    mounted() {
        let self = this;
        this.getComments();
        this.bus.$on('newCommentAdded', this.getComments);
    },
    data() {
        return {
            comments: []
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        getComments() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('artworks.get.comments', {id: this.order.id, artwork_id: this.artwork.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                       this.comments = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        deleteComment(index, id) {
            if(id) {
                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.delete(window.route('artworks.del.comments', {id: this.order.id, comment_id: id}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({data}) => {
                        if (data.errorMessage) {
                            self.setErrorMessage(data.errorMessage);
                            if (data.errors) {
                                self.setCommonErrors(data.errors);
                            }
                        } else {
                            //this.comments.splice(index, 1);
                            this.$emit('commentDeleted', {id: this.order.id, artwork_id: this.artwork.id});
                            this.getComments();
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setLoading(false);

                    });
            } else {
                this.comments.splice(index, 1);
            }
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    },
    watch: {
        artwork: {
            handler: function (after, before) {
                this.comments = [];
                if(after != null) {
                    this.getComments();
                }

            },
            deep: true,
        },
    }
}
</script>

<style scoped>

</style>
